/**
 * @module The Comment List
 */

import {AttributeLink, AttributeSetup, NodeUpgrade} from '@acng/frontend-stargazer';
import {attributeSelector} from '@acng/frontend-bounty/dom/query.js';
import {WatchGroup} from '@acng/frontend-relativity';

import {ctxGallery} from '../../core/context/gallery.js';
import {Actor as ListProvider} from '../../layout/context/list.js';
import {listComments} from '../service/http.js';
import {ctxCreatedComment} from '../context/created.js';

const name = 'comment-list';

AttributeSetup(name, () => {
  const limit = 20;
  const watch = WatchGroup(attributeSelector(name), ctxGallery, ctxCreatedComment);
  const provide = ListProvider();

  AttributeLink(name, (element) =>
    watch(element, (element, [gallery, created], [previous]) => {
      const {set_id} = gallery;

      if (set_id == previous?.set_id && set_id != created?.gallery.set_id) {
        return;
      }

      provide(
        element,
        async (offset) => await listComments(element, gallery, limit, offset),
        async (comment) => (element, engine) => NodeUpgrade(engine, comment),
      );
    }),
  );
});

export {name as COMMENT_LIST};
